// ** Icons Import
// import { Heart } from 'react-feather'
import langConfig from "@configs/langConfig"

const Footer = () => {
  const {t} = langConfig
  return (
    <p className='clearfix mb-0'>
      <span className='float-md-left d-block d-md-inline-block mt-25'>
        {t('COPYRIGHT © ', {'year': new Date().getFullYear()})}
      </span>
      <span className='float-md-right d-none d-md-block'>
        {t('Made with ❤️ in Saudi')}
      </span>
    </p>
  )
}

export default Footer
